import React, { useState } from 'react';
import withServices from '../../hocs/withServices';
import InputMask from 'react-input-mask';
import { useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import {
	Grid,
	Container,
	Paper,
	TextField,
	FormControlLabel,
	Checkbox,
	Button,
	Typography,
	IconButton, 
	InputAdornment
} from '@mui/material';
import './registration.scss';
import { toast } from 'react-toastify';
import AuthService from '../../services/authService';
import Constants from '../../common/constants';
import { useNavigate } from 'react-router-dom';
import { LoadingContainer } from '../../common/helpers/LoadingContainer';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function Registration({ services }) {
	const [isCheckedTerms, setIsCheckedTerms] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const [passErrText, setPassErrText] = useState('');
	const [passwordError, setPasswordError] = useState(false);

	const [showPassword, setShowPassword] = useState(false);
	const handleClickShowPassword = () => setShowPassword((prev) => !prev);
	const handleMouseDownPassword = (event) => event.preventDefault();

	const [loginErrText, setLoginErrText] = useState('');
	const [loginError, setLoginError] = useState(false);
	const [selectImage, setSelectImage] = useState();
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate ();

	const { register, handleSubmit, reset } = useForm();

	const imageChange = e => {
		if (e.target.files && e.target.files.length > 0) {
			setSelectImage(e.target.files[0]);
		}
	};

	const deleteSelectImage = () => {
		setSelectImage();
	};

	const handleCheckLogin = event => {
		AuthService.checkLogin(event.target.value)
			.then(response => {
				if (response.data) {
					setLoginErrText('Логин уже занят');
					setLoginError(true);
				} else {
					setLoginErrText('');
					setLoginError(false);
				}
			})
			.catch(error => {
				console.log(error);
				setErrorMessage(error)})
			.finally(()=>{
				setIsCheckedTerms(isCheckedTerms);
			});
	};
	const handleCheckPassword = event => {
		if (document.getElementById('pass').value !== event.target.value) {
			setPassErrText('Пароли не совпадают');
			setPasswordError(true);
		} else {
			setPassErrText('');
			setPasswordError(false);
		}
	};
	const handleCheckedChange = event => {
		setIsCheckedTerms(event.target.checked);
	};

	const onSubmitRegistration = async data => {
		data['avatar'] = selectImage;
			// if (selectImage && selectImage.size !== null) {
			// 	setLoading(true);
			// 	await FileUploadService.uploadPhotos(selectImage)
			// 		.then(response => {
			// 			const logotype = {
			// 				uid: uuidv4(),
			// 				name: selectImage.name,
			// 				response: response.data,
			// 				type: selectImage.type,
			// 				size: selectImage.size,
			// 				percent: 100,
			// 				status: 'done'
			// 			};
			// 			data['logoType'] = logotype;
			// 		})
			// 		.catch(error => {
			// 			toast.error('Изображение не загрузилось', {
			// 				position: 'top-right'
			// 			});
			// 		})
			// 		.finally(() => {
			// 			setLoading(false);
			// 		});
			// }
			// setLoading(true);
			await AuthService.registration(data)
				.then(response => {
					toast.success('На вашу почту выслана ссылка для активации аккаунта', {
						position: 'bottom-left'
					});
					navigate('/success-registered');


				})
				.catch(error => {
					console.log(error);
					setErrorMessage(error)})
				.finally(() => {
					setLoading(false);
					//reset();
				});
		// }
	};

	return (
		<>
			{loading ? (
				<LoadingContainer />
			) : (
				<Container
					className='reg-page'
					maxWidth='lg'
					sx={{ marginBottom: '50px' }}
				>
					<Grid
						sx={{
							width: '100%',
							textAlign: 'center',
							marginTop: '20px',
							marginBottom: '30px'
						}}
					>
						<h3 style={{ color: '#00357a', fontSize: '25px' }}>Регистрация</h3>
						{errorMessage && (
							<Typography variant='body1' color='error'>
								{errorMessage}
							</Typography>
						)}
					</Grid>
					<form onSubmit={handleSubmit(onSubmitRegistration)}>
						<Grid className='reg-block' container sx={{display: 'flex', justifyContent: 'center'}} >
							<Grid item xs={12} md={6}>
								<Paper className='reg-cards' sx={{ marginBottom: '25px' }}>
									<Grid
										sx={{
											width: '100%',
											marginBottom: '25px',
											display: 'flex'
										}}
									>
										<TextField
											{...register('name')}
											required
											label='Имя:'
											variant='outlined'
											fullWidth
											sx={{ marginRight: '10px' }}
										/>
										<TextField
											{...register('surname')}
											required
											label='Фамилия:'
											variant='outlined'
											fullWidth
											sx={{ marginRight: '10px' }}
										/>
										<TextField
											{...register('patronymic')}
											label='Отчество:'
											variant='outlined'
											fullWidth
										/>
									</Grid>
									<Grid
										sx={{
											width: '100%',
											display: 'flex',
											marginBottom: '25px'
										}}
									>
									<Grid item xs={12} md={6} sx={{ width: '50%' }}>
											<InputMask
												mask='999999999999'
												{...register('iin')}
												name='iin'
											>
												{inputProps => (
													<TextField
														required
														{...inputProps}
														label='ИИН:'
														variant='outlined'
													/>
												)}
											</InputMask>
										</Grid>
										<Grid
											item
											xs={12}
											md={6}
											sx={{ width: '50%' }}
										>
											<InputMask
												mask='99999999999'
												{...register('phoneNumber')}
												name='phoneNumber'
											>
												{inputProps => (
													<TextField
														required
														label='Номер телефона:'
														variant='outlined'
														fullWidth
														{...inputProps}
													/>
												)}
											</InputMask>
										</Grid>
									</Grid>									
									<Grid sx={{ width: '100%', marginBottom: '25px' }}>
										<TextField
											{...register('email')}
											required
											label='Электронная почта:'
											variant='outlined'
											fullWidth
											type='email'
										/>
									</Grid>
									<Grid
										sx={{
											width: '100%',
											marginBottom: '25px',
											display: 'flex'
										}}
									>
										<TextField
											{...register('password')}
											required
											id="pass"
											label="Пароль:"
											variant="outlined"
											fullWidth
											type={showPassword ? 'text' : 'password'}
											sx={{ marginRight: '10px' }}
											InputProps={{
												endAdornment: (
												<InputAdornment position="end">
													<IconButton
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
													edge="end"
													>
													{showPassword ? <VisibilityOff /> : <Visibility />}
													</IconButton>
												</InputAdornment>
												),
											}}
											/>
									</Grid>
									<Grid
										sx={{
											width: '100%',
											marginBottom: '25px',
											display: 'flex'
										}}
									>
										<Grid sx={{ width: '50%' }}>
											<p>Фотография (необязательно):</p>
										</Grid>
										<Grid sx={{ width: '50%' }}>
											{selectImage ? (
												<Grid
													sx={{
														width: '100%',
														display: 'flex',
														flexDirection: 'column',
														alignItems: 'center'
													}}
												>
													<img
														src={URL.createObjectURL(selectImage)}
														alt=''
														style={{ maxWidth: '50%', maxHeight: '320px' }}
													/>
													<Button
														sx={{ width: '100%' }}
														onClick={deleteSelectImage}
													>
														Удалить выбранный фото
													</Button>
												</Grid>
											) : (
												<Button
													variant='outlined'
													component='label'
													sx={{ width: '100%' }}
												>
													Загрузить файл
													<input
														type='file'
														hidden
														onChange={imageChange}
														accept='image/png, image/gif, image/jpeg'
													/>
												</Button>
											)}
										</Grid>
									</Grid>
									<Grid sx={{ width: '100%' }}>
										<Grid sx={{ width: '100%', marginBottom: "10px"}}>
											<FormControlLabel
												control={
													<Checkbox required onChange={handleCheckedChange} />
												}
												label={
													<>
														Я принимаю условия{' '}
														<a href='/terms' style={{ color: '#0837fe' }}>
															пользовательского соглашения
														</a>{' '}
														и даю согласие на обработку персональных данных
													</>
												}
											/>
										</Grid>
										<Button
											fullWidth
											variant='contained'
											disabled={!isCheckedTerms || passwordError}
											type='submit'
										>
											Завершить регистрацию
										</Button>
									</Grid>
								</Paper>
							</Grid>
						</Grid>
					</form>
				</Container>
			)}
		</>
	);
}

export default withServices()(Registration);
